import { render, staticRenderFns } from "./importNewFlowTask.vue?vue&type=template&id=0790164c"
import script from "./importNewFlowTask.vue?vue&type=script&lang=js"
export * from "./importNewFlowTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports